import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LANGUAGES } from '../../constants/languages';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: LANGUAGES.en,
    debug: false,
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (format === 'a_az' && lng === LANGUAGES.hu) {
          const vowels = [
            'a',
            'e',
            'i',
            'o',
            'u',
            'á',
            'é',
            'í',
            'ó',
            'ö',
            'ő',
            'ú',
            'ü',
            'ű',
          ];
          const firstLetter = (value[0] || '').toLowerCase();
          return vowels.includes(firstLetter) ? 'az ' : 'a ';
        }
        return value;
      },
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: () => {
        const timestamp = new Date();
        return `/locales/{{lng}}/{{ns}}.json?timestamp=${timestamp.getTime()}`;
      },
    },
  });

export default i18n;
